import React, { createContext, useContext, useState } from 'react';

export const SimulatorContext = createContext();

export const SimulatorProvider = ({ children }) => {
  const [simulatorData, setSimulatorData] = useState(null);
  const [environment, setEnvironment] = useState({
    wind_speed_mph: 0,
    wind_direction_deg: 0,
    temp_f: 59,
    altitude_ft: 0,
    humidity_pct: 50,
  });

  /**
   * Load club data into the simulator from Bag or History
   * @param {Object} data - Club data with ball_speed, launch_angle, spin_rate, etc.
   */
  const loadSimulator = (data) => {
    setSimulatorData({
      ...data,
      loadedAt: new Date().toISOString(),
    });
  };

  /**
   * Update environmental conditions
   * @param {Object} updates - Partial environment updates
   */
  const updateEnvironment = (updates) => {
    setEnvironment(prev => ({ ...prev, ...updates }));
  };

  /**
   * Clear simulator data
   */
  const clearSimulator = () => {
    setSimulatorData(null);
    setEnvironment({
      wind_speed_mph: 0,
      wind_direction_deg: 0,
      temp_f: 59,
      altitude_ft: 0,
      humidity_pct: 50,
    });
  };

  return (
    <SimulatorContext.Provider
      value={{
        simulatorData,
        environment,
        loadSimulator,
        updateEnvironment,
        clearSimulator,
      }}
    >
      {children}
    </SimulatorContext.Provider>
  );
};

export const useSimulator = () => {
  const context = useContext(SimulatorContext);
  if (!context) {
    throw new Error('useSimulator must be used within SimulatorProvider');
  }
  return context;
};
